/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssessmentTaskType } from './AssessmentTaskType';
import {
  AssessmentTaskTypeFromJSON,
  AssessmentTaskTypeFromJSONTyped,
  AssessmentTaskTypeToJSON,
} from './AssessmentTaskType';
import type { AssessmentStatusCount } from './AssessmentStatusCount';
import {
  AssessmentStatusCountFromJSON,
  AssessmentStatusCountFromJSONTyped,
  AssessmentStatusCountToJSON,
} from './AssessmentStatusCount';

/**
 *
 * @export
 * @interface AssessmentCount
 */
export interface AssessmentCount {
  /**
   *
   * @type {AssessmentStatusCount}
   * @memberof AssessmentCount
   */
  statusCategoryCount: AssessmentStatusCount;
  /**
   *
   * @type {AssessmentTaskType}
   * @memberof AssessmentCount
   */
  taskTypeCount: AssessmentTaskType;
  /**
   *
   * @type {{ [key: string]: number; }}
   * @memberof AssessmentCount
   */
  modelNameCount: { [key: string]: number };
}

/**
 * Check if a given object implements the AssessmentCount interface.
 */
export function instanceOfAssessmentCount(value: object): value is AssessmentCount {
  if (!('statusCategoryCount' in value) || value['statusCategoryCount'] === undefined) return false;
  if (!('taskTypeCount' in value) || value['taskTypeCount'] === undefined) return false;
  if (!('modelNameCount' in value) || value['modelNameCount'] === undefined) return false;
  return true;
}

export function AssessmentCountFromJSON(json: any): AssessmentCount {
  return AssessmentCountFromJSONTyped(json, false);
}

export function AssessmentCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentCount {
  if (json == null) {
    return json;
  }
  return {
    statusCategoryCount: AssessmentStatusCountFromJSON(json['status_category_count']),
    taskTypeCount: AssessmentTaskTypeFromJSON(json['task_type_count']),
    modelNameCount: json['model_name_count'],
  };
}

export function AssessmentCountToJSON(value?: AssessmentCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    status_category_count: AssessmentStatusCountToJSON(value['statusCategoryCount']),
    task_type_count: AssessmentTaskTypeToJSON(value['taskTypeCount']),
    model_name_count: value['modelNameCount'],
  };
}
